import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { Type } from '@spotify-internal/encore-web';
import {
  announcement,
  spacer12,
  spacer48,
  spacer24,
} from '@spotify-internal/encore-foundation';
import { sendEvent } from '../Tracking';
import { ButtonPrimaryAsLink } from '../ui';
import { defaultTheme } from '../Theme';
import { PageHead } from './PageHead';

const Layout = styled.div`
  display: flex;
  width: 100%;
  background-color: ${announcement};
  padding: 120px ${spacer24};
`;

const Content = styled.div`
  width: 100%;
  max-width: 800px;
  text-align: center;
  margin: auto;
  p {
    margin-top: ${spacer48};
    margin-bottom: ${spacer12};
  }
`;

export const NotFound: React.FC = () => {
  React.useEffect(() => {
    sendEvent({
      eventCategory: `Frodor - Not Found`,
      eventAction: 'view',
      eventLabel: 'Not Found',
    });
  }, []);

  return (
    <ThemeProvider theme={defaultTheme} data-testid="not-found">
      <PageHead title="Not found" />

      <Layout>
        <Content>
          <Type.h1 variant="display2">We couldn’t find that page.</Type.h1>

          <Type.p variant="body1">
            The link may be broken or we’ve taken the page down.
          </Type.p>

          <ButtonPrimaryAsLink href="/?ref=error" prefetch={false}>
            Our Homepage
          </ButtonPrimaryAsLink>
        </Content>
      </Layout>
    </ThemeProvider>
  );
};
